import { CreateSubscriptionResult } from "./CreateSubscriptionResult.js";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UpdateSubscriptionResult extends CreateSubscriptionResult {

}
